import * as React from 'react';

import ContentGateContentCds from 'bundles/video-logged-out-page/components/content-gates/ContentGateContent';
import { LOGGED_OUT_VIDEO_ALLOWANCE } from 'bundles/video-logged-out-page/constants';

const ContentGateVideoOverlay = () => {
  return (
    <div className="vlp-gate-video-overlay">
      <div className="vlp-gate-video-overlay-content">
        <ContentGateContentCds videoAllowance={LOGGED_OUT_VIDEO_ALLOWANCE} />
      </div>
    </div>
  );
};

export default ContentGateVideoOverlay;
